import React, { lazy } from "react";
const restrictedUserRoutes = [
  {
    path: "/",
    Component: lazy(() => import("../pages/Dashboard")),
    permission: ["*"],
  },
  {
    path: "/user-profile",
    Component: lazy(() => import("../pages/ProfileInformation")),
    permission: ["*"],
  },
  {
    path: "/profile",
    Component: lazy(() => import("../pages/UserProfile/ProfilePage")),
    permission: ["*"],
  },
  {
    path: "/additional-information",
    Component: lazy(() => import("../components/AdditionalInformation/AdditionalInfoParent")),
    role: "shipper",
    permission: ["profile:update"],
  },
  {
    path: "/additional-information-vehicle-owner",
    Component: lazy(() => import("../components/AdditionalInformationVehicleOwner/AdditionalInfoParent")),
    role: "vehicle_owner",
    permission: ["profile:update"],
    // permission: ["vehicle_owner:update"],
  },
  {
    path: "/settings",
    Component: lazy(() => import("../pages/Setting")),
    permission: ["*"],
  },
  {
    path: "/users",
    Component: lazy(() => import("../pages/PlatformAdmin")),
    permission: ["user:list_all"],
  },
  {
    path: "/users/create",
    Component: lazy(() => import("../components/PlatformAdmin/create")),
    permission: ["user:create"],
  },
  {
    path: "/users/edit/:id",
    Component: lazy(() => import("../components/PlatformAdmin/edit")),
    permission: ["user:update"],
  },
  {
    path: "/users/details/:id",
    Component: lazy(() => import("../components/PlatformAdmin/view")),
    permission: ["user:detail"],
  },
  {
    path: "/vehicle-owner-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/VehicleOwnerReport")),
    permission: ["*"],
  },
  {
    path: "/driver-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/DriverReport")),
    permission: ["*"],
  },
  {
    path: "/vehicle-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/VehicleReport")),
    permission: ["*"],
  },
  {
    path: "/expiry-report",
    Component: lazy(() => import("../components/VehicleOwner/reports/ExpiryReport")),
    permission: ["*"],
  },
  {
    path: "/vehicle-history",
    Component: lazy(() => import("../components/VehicleOwner/reports/VehicleLogHistory")),
    permission: ["*"],
  },
  {
    path: "/GPS-report",
    Component: lazy(() => import("../components/VehicleOwner/reports/GPSReport")),
    permission: ["*"],
  },
  {
    path: "/trip-report",
    Component: lazy(() => import("../components/VehicleOwner/reports/TripReports")),
    permission: ["*"],
  },
  {
    path: "/driver-reports",
    Component: lazy(() => import("../components/VehicleOwner/reports/DriverReports")),
    permission: ["*"],
  },
  {
    path: "/vehicle-Checklist-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/VehicleChecklist")),
    permission: ["*"],
  },
  {
    path: "/vehicle-Checklist-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/VehicleChecklist")),
    permission: ["*"],
  },
  {
    path: "/user-log-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/UserLogReport")),
    permission: ["*"],
  },
  {
    path: "/user-delete-request-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/UserDeleteRequestReport")),
    permission: ["account_deletion_request:list_all"],
  },
  {
    path: "/driver",
    Component: lazy(() => import("../components/Driver/ListDriver/ListDriver")),
    permission: ["driver:list", "driver:list_all"],
  },
  {
    path: "/driver/create",
    Component: lazy(() => import("../components/Driver/CreateEditDriver/CreateDriver")),
    permission: ["driver:create"],
  },
  {
    path: "/driver/edit/:id",
    Component: lazy(() => import("../components/Driver/CreateEditDriver/EditDriver")),
    permission: ["driver:update"],
  },
  {
    path: "/tqms-vehicle-owner",
    Component: lazy(() => import("../components/TQMS/VehicleOwner")),
    permission: ["tqms:list_all"],
  },
  {
    path: "/tqms-pending-vehicle-all",
    Component: lazy(() => import("../components/TQMS/TQMSPendingVehicle")),
    permission: ["vehicle:list_all"],
  },
  {
    path: "/lodbod-pending-vehicle",
    Component: lazy(() => import("../components/TQMS/LoadBoardPendingVehicle")),
    permission: ["vehicle:list_all"],
  },
  {
    path: "/tqms-vehicle",
    Component: lazy(() => import("../components/TQMS/Vehicle")),
    permission: ["*"],
  },
  {
    path: "/pending-vehicle",
    Component: lazy(() => import("../components/TQMS/VehicleOfVehicleOwner")),
    permission: ["*"],
  },
  {
    path: "/vehicle-details/:id",
    Component: lazy(() => import("../components/TQMS/VehicleDetails")),
    permission: ["*"],
  },
  {
    path: "/pending/vehicle-details/:id",
    Component: lazy(() => import("../components/TQMS/PendingVehicleDetails")),
    permission: ["*"],
  },
  {
    path: "/rejected-vehicle",
    Component: lazy(() => import("../components/TQMS/RejectedVehicle")),
    permission: ["*"],
  },
  {
    path: "/declined-vehicle",
    Component: lazy(() => import("../components/TQMS/DeclinedVehicle")),
    permission: ["*"],
  },
  {
    path: "/edit-requested-vehicle",
    Component: lazy(() => import("../components/TQMS/EditRequestedVehicle")),
    permission: ["*"],
  },
  {
    path: "/tqms-driver",
    Component: lazy(() => import("../components/TQMS/Driver")),
    permission: ["tqms:list_all"],
  },
  {
    path: "/driver/details/:id",
    Component: lazy(() => import("../components/Driver/DriverDetails/index")),
    permission: ["driver:detail"],
  },
  {
    path: "/shipper",
    Component: lazy(() => import("../components/Shipper/ListShipper/ListShipper")),
    permission: ["shipper:list_all"],
  },
  {
    path: "/shipper/create",
    Component: lazy(() => import("../components/Shipper/CreateEditShipper/CreateShipper")),
    permission: ["shipper:create"],
  },
  {
    path: "/shipper/edit/:id",
    Component: lazy(() => import("../components/Shipper/CreateEditShipper/EditShipper")),
    permission: ["shipper:update"],
  },
  {
    path: "/shipper/details/:id",
    Component: lazy(() => import("../components/Shipper/ShipperDetails/index")),
    permission: ["shipper:detail"],
  },
  {
    path: "/vehicle-owner",
    Component: lazy(() => import("../pages/VehicleOwner")),
    permission: ["vehicle_owner:list_all"],
  },
  {
    path: "/live-tracking",
    Component: lazy(() => import("../pages/LiveTracking/index")),
    permission: ["*"],
  },
  // {
  //   path: "/live-tracking",
  //   Component: lazy(
  //     () => import("../components/VehicleOwner/VehicleOwnerDetails/index")
  //   ),
  //   permission: ["*"],
  // },
  {
    path: "/roles",
    Component: lazy(() => import("../components/Roles&Permissions/RolesList")),
    permission: ["role:list_all"],
  },
  {
    path: "/roles/create",
    Component: lazy(() => import("../components/Roles&Permissions/Create")),
    permission: ["role:create"],
  },
  {
    path: "/roles/permissions/:id",
    Component: lazy(() => import("../components/Roles&Permissions/RolesPermissions")),
    permission: ["*"],
  },
  {
    path: "/vehicle-owner/create",
    Component: lazy(() => import("../components/VehicleOwner/CreateEditVehicleOwner/CreateVehicleOwner")),
    permission: ["vehicle_owner:create"],
  },
  {
    path: "/vehicle-owner/edit/:id",
    Component: lazy(() => import("../components/VehicleOwner/CreateEditVehicleOwner/EditVehicleOwner")),
    permission: ["vehicle_owner:update"],
  },
  {
    path: "/vehicle-owner/details/:id",
    Component: lazy(() => import("../components/VehicleOwner/VehicleOwnerDetails/index")),
    permission: ["vehicle_owner:detail"],
  },
  {
    path: "/contract-details/:id",
    Component: lazy(() => import("../components/Contract/ContractEdit/index")),
    permission: ["*"],
  },
  {
    path: "/digital-contract",
    Component: lazy(() => import("../pages/DigitalContract/index")),
    permission: ["*"],
  },
  {
    path: "/add/digital-contract",
    Component: lazy(() => import("../pages/DigitalContract/AddDigitalContract")),
    permission: ["*"],
  },
  {
    path: "/contract",
    Component: lazy(() => import("../pages/Contract/index")),
    permission: ["*"],
  },
  {
    path: "/add/contract/:type",
    Component: lazy(() => import("../pages/Contract/AddContract")),
    permission: ["*"],
  },
  {
    path: "/fixed-vehicle-contract",
    Component: lazy(() => import("../pages/FixedVehicleContract/index")),
    permission: ["*"],
  },
  {
    path: "/add/fixed-vehicle-contract",
    Component: lazy(() => import("../pages/FixedVehicleContract/AddFixedVehicleContract")),
    permission: ["*"],
  },
  {
    path: "/edit/fixed-vehicle-contract",
    Component: lazy(() => import("../pages/FixedVehicleContract/AddFixedVehicleContract")),
    permission: ["*"],
  },
  {
    path: "/variable-vehicle-contract",
    Component: lazy(() => import("../pages/VariableVehicleContract/index")),
    permission: ["*"],
  },
  {
    path: "/add/variable-vehicle-contract",
    Component: lazy(() => import("../pages/VariableVehicleContract/AddVariableVehicleContract")),
    permission: ["*"],
  },
  {
    path: "/edit/variable-vehicle-contract",
    Component: lazy(() => import("../pages/VariableVehicleContract/AddVariableVehicleContract")),
    permission: ["*"],
  },
  {
    path: "/declined-vehicle-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/DeclinedVehiclesReport")),
    permission: ["*"],
  },
  {
    path: "/edit-request-vehicle-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/EditRequestVehicleReport")),
    permission: ["*"],
  },
  {
    path: "/awaiting-approval-vehicle",
    Component: lazy(() => import("../components/PlatformAdmin/reports/AwaitingApprovalVehicle")),
    permission: ["*"],
  },
  {
    path: "/awaiting-admin-approval-vehicle",
    Component: lazy(() => import("../pages/AwaitingAdminApproval/AwaitingAdminApproval")),
    permission: ["*"],
  },
  {
    path: "/server-logs-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/ServerLogsReport")),
    permission: ["*"],
  },
  {
    path: "/shipment-tracking-report",
    Component: lazy(() => import("../components/PlatformAdmin/reports/ShipmentReport/ShipmentTrackingReport")),
    permission: ["shipment_tracking_report:list_all"],
  },
  {
    path: "/shipment-calender",
    Component: lazy(() => import("../components/PlatformAdmin/reports/ShipmentReport/ShipmentCalenderReport/ShipmentCalender")),
    permission: ["shipment_calendar_report:list_all"],
  },
  {
    path: "/shipment-dispatch",
    Component: lazy(() => import("../components/PlatformAdmin/reports/ShipmentReport/ShipmentDispatch")),
    permission: ["shipment_dispatch_report:list_all"],
  },
  {
    path: "/approval",
    Component: lazy(() => import("../pages/Approval/Approval")),
    permission: ["*"],
  },
  {
    path: "/subscription-plans/details/:id",
    Component: lazy(() => import("../components/Subscription/Details/SubscriptionPlanDetails")),
    permission: ["*"],
  },
  {
    path: "/blocked-user-report",
    Component: lazy(() => import("../pages/BlockedUser")),
    permission: ["report:list_all"],
  },
  {
    path: "/promotions",
    Component: lazy(() => import("../pages/Promitions")),
    permission: ["*"],
  },
  {
    path: "/promotion/create",
    Component: lazy(() => import("../pages/Promitions/AddPromotion")),
    permission: ["promotion_code:create"],
  },
  {
    path: "/promotion/update/:id",
    Component: lazy(() => import("../pages/Promitions/UpdatePromotion")),
    permission: ["promotion_code:update"],
  },
  {
    path: "/promotion/view/:id",
    Component: lazy(() => import("../pages/Promitions/ViewPromotion")),
    permission: ["promotion_code:list_all"],
  },
  {
    path: "/tutorial-content",
    Component: lazy(() => import("../components/Content/Tutorial")),
    permission: ["tutorial_content:list_all"],
  },
  {
    path: "/promotional-content",
    Component: lazy(() => import("../components/Content/Promotion")),
    permission: ["promotion_content:list_all"],
  },
  {
    path: "/promotional-content/create",
    Component: lazy(() => import("../components/Content/Create/CreatePromotionalContent")),
    permission: ["promotion_content:create"],
  },
  {
    path: "/tutorial-content/create",
    Component: lazy(() => import("../components/Content/Create/CreateTutorialContent")),
    permission: ["tutorial_content:create"],
  },
  {
    path: "/promotional-content/edit/:id",
    Component: lazy(() => import("../components/Content/Edit/EditPromotionalContent")),
    permission: ["promotion_content:update"],
  },
  {
    path: "/tutorial-content/edit/:id",
    Component: lazy(() => import("../components/Content/Edit/EditTutorialContent")),
    permission: ["tutorial_content:update"],
  },
  {
    path: "/point/payment-completed",
    Component: lazy(() => import("../../../core/presentation/pages/PaymentCompleted")),
    permission: ["*"],
  },
  {
    path: "/point-report",
    Component: lazy(() => import("../components/VehicleOwner/reports/PointPurchaseReport")),
    permission: ["*"],
  },
  {
    path: "/refund",
    Component: lazy(() => import("../pages/Refund")),
    permission: ["*"],
  },
  {
    path: "*",
    Component: lazy(() => import("../../../core/presentation/pages/NotFound")),
    permission: ["*"],
  },
  {
    path: "/awaiting-account-approval",
    Component: lazy(() => import("../components/PlatformAdmin/reports/AwaitingAccountApproval")),
    permission: ["account_approval:list_all"],
  },
  {
    path: "/payment-commission/detail/:id",
    Component: lazy(() => import("../components/PaymentCommission/PaymentCommissionDetail")),
    permission: ["payment_commission:detail"],
  },
  {
    path: "/payment-commission/edit/:id",
    Component: lazy(() => import("../components/PaymentCommission/PaymentCommissionUpdate")),
    permission: ["payment_commission:update"],
  },
];
export default restrictedUserRoutes;
